import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IDesignation } from '../types';
import { DesignationRow } from './designation-row';

interface Props {
  tableProps: TableProps;
  rows?: IDesignation[];
  loading: boolean;
  canAddDesignation: string;
}

const DesignationList = ({ tableProps, rows, loading, canAddDesignation }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'name', label: 'Name', align: 'center' },
    { id: 'desc', label: 'Description', align: 'center' },
    ...(canAddDesignation
      ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }]
      : []),
  ];
  return (
    <PaginatedTable<IDesignation>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <DesignationRow
          row={row}
          canAddDesignation={canAddDesignation}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};

export { DesignationList };
